import { Routes } from '@angular/router';
import { PublicWishlistComponent } from './shared/components/public-wishlist/public-wishlist.component';
import { AuthGuard } from './auth/helpers/auth.guard';
import { SvelteGuard } from './auth/helpers/svelte.guard';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

export const routes: Routes = [
  /* Landing module */
  { path: 'landing', loadChildren: () => import('./landings/landings.module').then((m) => m.LandingsModule) },
  { path: 'es/landing', loadChildren: () => import('./landings/landings.module').then((m) => m.LandingsModule) },
  { path: 'de/landing', loadChildren: () => import('./landings/landings.module').then((m) => m.LandingsModule) },
  { path: 'pt-br/landing', loadChildren: () => import('./landings/landings.module').then((m) => m.LandingsModule) },

  { path: 'ref/:referralUser', loadChildren: () => import('./referral/referral.module').then((m) => m.ReferralModule) },
  {
    path: 'es/ref/:referralUser',
    loadChildren: () => import('./referral/referral.module').then((m) => m.ReferralModule),
  },
  {
    path: 'de/ref/:referralUser',
    loadChildren: () => import('./referral/referral.module').then((m) => m.ReferralModule),
  },
  {
    path: 'pt-br/ref/:referralUser',
    loadChildren: () => import('./referral/referral.module').then((m) => m.ReferralModule),
  },

  /* Profile module */
  {
    path: 'my-profile',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'es/my-profile',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'de/my-profile',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'pt-br/my-profile',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
  },

  /* Public wishlists module */

  { path: 'wishlist/:id', component: PublicWishlistComponent },
  { path: 'es/wishlist/:id', component: PublicWishlistComponent },
  { path: 'de/wishlist/:id', component: PublicWishlistComponent },
  { path: 'pt-br/wishlist/:id', component: PublicWishlistComponent },

  /* Blog module */

  { path: 'blog', canActivate: [SvelteGuard], component: NotFoundComponent },
  { path: 'es/blog', canActivate: [SvelteGuard], component: NotFoundComponent },
  { path: 'de/blog', canActivate: [SvelteGuard], component: NotFoundComponent },
  { path: 'pt-br/blog', canActivate: [SvelteGuard], component: NotFoundComponent },

  /* Affiliate module */
  {
    path: 'affiliate-profile',
    loadChildren: () => import('./affiliate/affiliate.module').then((m) => m.AffiliateModule),
  },
  {
    path: 'es/affiliate-profile',
    loadChildren: () => import('./affiliate/affiliate.module').then((m) => m.AffiliateModule),
  },
  {
    path: 'de/affiliate-profile',
    loadChildren: () => import('./affiliate/affiliate.module').then((m) => m.AffiliateModule),
  },
  {
    path: 'pt-br/affiliate-profile',
    loadChildren: () => import('./affiliate/affiliate.module').then((m) => m.AffiliateModule),
  },

  /* Become module */

  { path: 'affiliates', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },
  { path: 'es/affiliates', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },
  { path: 'de/affiliates', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },
  { path: 'pt-br/affiliates', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },

  { path: 'partnerships', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },
  { path: 'es/partnerships', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },
  { path: 'de/partnerships', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },
  { path: 'pt-br/partnerships', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },

  { path: 'sponsorship-program', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },
  { path: 'es/sponsorship-program', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },
  { path: 'de/sponsorship-program', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },
  {
    path: 'pt-br/sponsorship-program',
    loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule),
  },

  /* Help module */

  { path: 'help', loadChildren: () => import('./help/help.module').then((m) => m.HelpModule) },
  { path: 'es/ayuda', loadChildren: () => import('./help/help.module').then((m) => m.HelpModule) },
  { path: 'de/hilfe', loadChildren: () => import('./help/help.module').then((m) => m.HelpModule) },
  { path: 'pt-br/ajuda', loadChildren: () => import('./help/help.module').then((m) => m.HelpModule) },

  {
    path: 'my-playlists',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'es/my-playlists',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'de/my-playlists',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'pt-br/my-playlists',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },

  /* Auth pages module.
   * We must provide data with the path of the page so that we can load the correct page.
   * */
  {
    path: 'login',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'es/login',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'de/login',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'pt-br/login',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },

  {
    path: 'join',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'es/join',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'de/join',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'pt-br/join',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },

  /*
   * Free trial module
   */
  {
    path: 'free-trial',
    loadChildren: () => import('./trial/trial.module').then((m) => m.TrialModule),
  },
  {
    path: 'es/free-trial',
    loadChildren: () => import('./trial/trial.module').then((m) => m.TrialModule),
  },
  {
    path: 'de/free-trial',
    loadChildren: () => import('./trial/trial.module').then((m) => m.TrialModule),
  },
  {
    path: 'pt-br/free-trial',
    loadChildren: () => import('./trial/trial.module').then((m) => m.TrialModule),
  },

  /* Cart module */

  { path: 'checkout', canActivate: [SvelteGuard], component: NotFoundComponent },
  { path: 'es/checkout', canActivate: [SvelteGuard], component: NotFoundComponent },
  { path: 'de/checkout', canActivate: [SvelteGuard], component: NotFoundComponent },
  { path: 'pt-br/checkout', canActivate: [SvelteGuard], component: NotFoundComponent },

  { path: 'payments', canActivate: [SvelteGuard], component: NotFoundComponent },
  { path: 'es/payments', canActivate: [SvelteGuard], component: NotFoundComponent },
  { path: 'de/payments', canActivate: [SvelteGuard], component: NotFoundComponent },
  { path: 'pt-br/payments', canActivate: [SvelteGuard], component: NotFoundComponent },

  { path: 'payments/receipt', canActivate: [SvelteGuard], component: NotFoundComponent },
  { path: 'es/payments/receipt', canActivate: [SvelteGuard], component: NotFoundComponent },
  { path: 'de/payments/receipt', canActivate: [SvelteGuard], component: NotFoundComponent },
  { path: 'pt-br/payments/receipt', canActivate: [SvelteGuard], component: NotFoundComponent },

  {
    path: 'shorts',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },

  /* Sound effects search module */
  {
    path: 'sound-effects',
    children: [
      {
        path: 'category/:categorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'category/:categorySlug/:subCategorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      // SFX Detail
      {
        path: ':slug/:id',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      // Search home
      {
        path: '',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'es/sound-effects',
    children: [
      {
        path: 'category/:categorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'category/:categorySlug/:subCategorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: ':slug/:id',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: '',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'de/sound-effects',
    children: [
      {
        path: 'category/:categorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'category/:categorySlug/:subCategorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: ':slug/:id',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: '',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'pt-br/sound-effects',
    children: [
      {
        path: 'category/:categorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'category/:categorySlug/:subCategorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: ':slug/:id',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: '',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
    ],
  },

  /* Royalty free music module. The order of the routes matters here. The last two routes must not be moved. */
  {
    path: 'royalty-free-music',
    children: [
      {
        path: 'genre/:categorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'genre' },
      },
      {
        path: 'genre/:categorySlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'genre' },
      },
      {
        path: 'mood/:categorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'mood' },
      },
      {
        path: 'mood/:categorySlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'mood' },
      },
      {
        path: 'tag/:tagSlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: ':slug/:id',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: '',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'es/royalty-free-music',
    children: [
      {
        path: 'genre/:categorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'genre' },
      },
      {
        path: 'genre/:categorySlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'genre' },
      },
      {
        path: 'mood/:categorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'mood' },
      },
      {
        path: 'mood/:categorySlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'mood' },
      },
      {
        path: 'tag/:tagSlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: ':slug/:id',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: '',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'de/royalty-free-music',
    children: [
      {
        path: 'genre/:categorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'genre' },
      },
      {
        path: 'genre/:categorySlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'genre' },
      },
      {
        path: 'mood/:categorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'mood' },
      },
      {
        path: 'mood/:categorySlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'mood' },
      },
      {
        path: 'tag/:tagSlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: ':slug/:id',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: '',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'pt-br/royalty-free-music',
    children: [
      {
        path: 'genre/:categorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'genre' },
      },
      {
        path: 'genre/:categorySlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'genre' },
      },
      {
        path: 'mood/:categorySlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'mood' },
      },
      {
        path: 'mood/:categorySlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
        data: { categoryType: 'mood' },
      },
      {
        path: 'tag/:tagSlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: ':slug/:id',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: '',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
    ],
  },

  /* Intros and Outros module.
   ** The order of the routes matters here.
   * The last two routes must not be moved.
   * */

  {
    path: 'intros',
    children: [
      {
        path: 'tag/:tagSlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: ':slug/:id',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: '',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'es/intros',
    children: [
      {
        path: 'tag/:tagSlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: ':slug/:id',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: '',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'de/intros',
    children: [
      {
        path: 'tag/:tagSlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: ':slug/:id',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: '',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'pt-br/intros',
    children: [
      {
        path: 'tag/:tagSlug',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'tag/:tagSlug/page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: 'page/:page',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: ':slug/:id',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
      {
        path: '',
        canActivate: [SvelteGuard],
        component: NotFoundComponent,
      },
    ],
  },

  /* About module. */

  { path: 'about', loadChildren: () => import('./about/about.module').then((m) => m.AboutModule) },
  { path: 'es/about', loadChildren: () => import('./about/about.module').then((m) => m.AboutModule) },
  { path: 'de/about', loadChildren: () => import('./about/about.module').then((m) => m.AboutModule) },
  { path: 'pt-br/about', loadChildren: () => import('./about/about.module').then((m) => m.AboutModule) },

  /* Informative module. */

  { path: 'contact', loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule) },
  {
    path: 'es/contact',
    loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule),
  },
  {
    path: 'de/contact',
    loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule),
  },
  {
    path: 'pt-br/contact',
    loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule),
  },

  {
    path: 'nonprofit',
    loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule),
  },
  {
    path: 'es/nonprofit',
    loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule),
  },
  {
    path: 'de/nonprofit',
    loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule),
  },
  {
    path: 'pt-br/nonprofit',
    loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule),
  },

  {
    path: 'education',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'es/education',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'de/education',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'pt-br/education',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },

  {
    path: 'in-store-music',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'es/in-store-music',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'de/in-store-music',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'pt-br/in-store-music',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  // Explore module.
  {
    path: 'explore',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'es/explore',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'de/explore',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'pt-br/explore',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'subscriptions',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'es/subscriptions',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'de/subscriptions',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'pt-br/subscriptions',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },

  { path: 'premium', canActivate: [SvelteGuard], component: NotFoundComponent },
  {
    path: 'es/premium',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'de/premium',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'pt-br/premium',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },

  { path: 'business', canActivate: [SvelteGuard], component: NotFoundComponent },
  {
    path: 'es/business',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'de/business',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'pt-br/business',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },

  {
    path: 'collections',
    loadChildren: () => import('./collections/collections.module').then((m) => m.CollectionsModule),
  },
  {
    path: 'es/collections',
    loadChildren: () => import('./collections/collections.module').then((m) => m.CollectionsModule),
  },
  {
    path: 'de/collections',
    loadChildren: () => import('./collections/collections.module').then((m) => m.CollectionsModule),
  },
  {
    path: 'pt-br/collections',
    loadChildren: () => import('./collections/collections.module').then((m) => m.CollectionsModule),
  },

  /**
   * Assistant studio routes. Added here to navigate to the assistant (Svelte) from Angular.
   */
  {
    path: 'studio',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'es/studio',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'de/studio',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'pt-br/studio',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },

  {
    path: 'shortcap',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'es/shortcap',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'de/shortcap',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'pt-br/shortcap',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },

  {
    path: '',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'es',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'de',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },
  {
    path: 'pt-br',
    canActivate: [SvelteGuard],
    component: NotFoundComponent,
  },

  /* Landings module. */
  { path: ':landingSlug', loadChildren: () => import('./landings/landings.module').then((m) => m.LandingsModule) },
  { path: 'es/:landingSlug', loadChildren: () => import('./landings/landings.module').then((m) => m.LandingsModule) },
  { path: 'de/:landingSlug', loadChildren: () => import('./landings/landings.module').then((m) => m.LandingsModule) },
  {
    path: 'pt-br/:landingSlug',
    loadChildren: () => import('./landings/landings.module').then((m) => m.LandingsModule),
  },

  { path: '**', component: NotFoundComponent },
];
